const url = '/amadeus-gateway';
const Provider = 'AmadeusGateway';
const dbModel = 'AmadeusGateway';

export { url, Provider, dbModel };
